// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Yt_J_","isWidthContainer":"_20BCfJ","currentPage":"_3gkJW_","link":"_1rEfUW","arrow":"_2a9T9S"};